<div class="flex flex-col gap-xl items-center">
  <div class="flex flex-col gap-md text-center">
    <core-icon icon="wifi_tethering_off" class="text-content-action-primary" size="xl"/>
    <h1>Der Chatbot ist aktuell offline.</h1>
    <div>Wir entschuldigen uns dafür, dass unser Chatbot momentan nicht verfügbar ist. Selbstverständlich bemühen wir
      uns
      den Chatbot schnellst möglichst wieder online zu bringen. Danke für Ihr Verständnis!
    </div>
  </div>
  <core-button iconLeft="refresh" (triggered)="authService.login()">Erneut versuchen</core-button>
</div>
